import { createStorageAtomFactory } from '@exodus/atoms';
import { createEmptyAccounts } from '../module/utils.js';
export default function createExternalWalletAddressesAtom({ storage, }) {
    const atomFactory = createStorageAtomFactory({ storage });
    return atomFactory({
        key: 'externalWalletAddresses',
        defaultValue: createEmptyAccounts(),
        isSoleWriter: true,
    });
}
